import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

const highlights = newsList.slice(0, 5);
const [lead, ...rest] = highlights;

export default function NewsHighlights() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
            <span className="h-5 w-1 rounded-full bg-primary-500"></span>
            最新娱乐资讯
          </h2>
          <p className="mt-1 text-xs text-foreground-500">影视圈动态与深度报道，每日更新</p>
        </div>
        <Link
          to="/news"
          className="flex cursor-pointer items-center gap-0.5 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
        >
          更多资讯
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <Link
        to={`/news/${lead.id}`}
        className="group mb-4 block cursor-pointer overflow-hidden rounded-lg border border-background-200 transition-colors hover:border-primary-300"
      >
        <div className="flex flex-col sm:flex-row">
          <div className="h-44 w-full shrink-0 overflow-hidden sm:h-40 sm:w-60">
            <img
              src={lead.cover}
              alt={lead.title}
              title={`${lead.title} - 爱妻艺娱乐资讯`}
              className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="flex flex-1 flex-col justify-center p-4">
            <span className="flex items-center gap-2 text-xs text-secondary-600">
              <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
                {lead.category}
              </span>
              {lead.date}
            </span>
            <h3 className="mt-2 text-base font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-lg">
              {lead.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{lead.summary}</p>
          </div>
        </div>
      </Link>

      <ul className="flex flex-col divide-y divide-background-200">
        {rest.map((item) => (
          <li key={item.id}>
            <Link to={`/news/${item.id}`} className="group flex cursor-pointer items-start gap-3 py-3">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-sm bg-accent-100 text-xs font-semibold text-accent-700">
                <i className="ri-flashlight-fill"></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                  <span>{item.date}</span>
                  <span className="flex items-center gap-0.5">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}